






















































import _ from 'lodash';
import { defineComponent, ref, Ref, onMounted } from '@vue/composition-api';
import { GetUserResponse } from '@oare/types';
import sl from '@/serviceLocator';

export default defineComponent({
  props: {
    groupId: {
      type: String,
      required: true,
    },
  },
  setup({ groupId }) {
    const deleteUserLoading = ref(false);
    const deleteUserDialog = ref(false);
    const loading = ref(true);

    const allUsers: Ref<GetUserResponse[]> = ref([]);
    const groupUsers: Ref<GetUserResponse[]> = ref([]);
    const selectedDeleteUsers: Ref<GetUserResponse[]> = ref([]);
    const usersHeaders = ref([{ text: 'Name', value: 'name' }]);
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const removeUsers = async () => {
      const userUuids = selectedDeleteUsers.value.map(user => user.uuid);
      deleteUserLoading.value = true;
      try {
        await server.removeUsersFromGroup(Number(groupId), { userUuids });
        deleteUserDialog.value = false;
        selectedDeleteUsers.value = [];
        actions.showSnackbar('Successfully removed user(s).');
      } catch (err) {
        actions.showErrorSnackbar(
          'Could not remove user(s). Please try again.',
          err as Error
        );
      } finally {
        deleteUserLoading.value = false;
      }
      groupUsers.value = groupUsers.value.filter(
        user => !userUuids.includes(user.uuid)
      );
    };

    onMounted(async () => {
      loading.value = true;
      try {
        allUsers.value = await server.getAllUsers();
        groupUsers.value = allUsers.value.filter(user =>
          user.groups.includes(Number(groupId))
        );
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading users. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    return {
      deleteUserLoading,
      deleteUserDialog,
      loading,
      allUsers,
      groupUsers,
      selectedDeleteUsers,
      usersHeaders,
      removeUsers,
    };
  },
});
